import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SystemService } from './system.service';
import { BTokenService } from './bToken.service';
import { PubSubService } from './pubSub.service';
import { BSessionStorage } from './bSessionStorage.service';
import { BLocalStorageService } from './bLocalStorage.service';
import { Router } from '@angular/router';
import { NotificationService } from './notification.service';
var BLoginService = (function () {
    function BLoginService(http, pubSubService, router, notificationService) {
        this.http = http;
        this.pubSubService = pubSubService;
        this.router = router;
        this.notificationService = notificationService;
        this.loginCompleted = new EventEmitter();
        this.systemService = new SystemService();
        this.bTokenService = new BTokenService();
        this.bSessionStorage = new BSessionStorage();
        this.bLocalStorageService = new BLocalStorageService();
    }
    BLoginService.prototype.login = function (userName, password, isRemember) {
        var _this = this;
        this.appProperties = this.systemService.getVal('properties');
        this.loginUrl = this.systemService.getAuthUrl() + this.appProperties.appDataSource + '/' + this.appProperties.appName;
        var uuid = this.systemService.deviceUUID;
        return this.http.post(this.loginUrl, { username: userName, password: password, uuid: uuid }).map(function (result) {
            var tokensObj = result;
            if (tokensObj) {
                _this.bTokenService.updateTokens(tokensObj, isRemember);
            }
            if (_this.systemService.getVal('firebaseSenderId') != 'FIREBASE_SENDER_ID' && _this.systemService.getVal('firebaseAuthKey') != 'FIREBASE_AUTH_KEY') {
                _this.pubSubService.$pub('loginComplete');
            }
            return (result);
        }, function (error) {
            return (error);
        });
    };
    BLoginService.prototype.isLoggedIn = function () {
        if (this.bSessionStorage.getValue('accessToken') && this.bSessionStorage.getValue('refreshToken') && this.bSessionStorage.getValue('accessToken') != 'null' && this.bSessionStorage.getValue('refreshToken') != 'null') {
            return true;
        }
        return false;
    };
    BLoginService.prototype.logout = function () {
        this.bSessionStorage.clearSessionStorage();
        this.bLocalStorageService.clearLocalStorage();
        return true;
    };
    return BLoginService;
}());
export { BLoginService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/bLogin.service.ts.pre-build-optimizer.js